// 开发环境的商户id
const _dev_identityId = '4jlfe1imqsee';

const isBrowser = typeof location !== 'undefined';
export const identityId =
  !import.meta.env || import.meta.env.DEV || !isBrowser
    ? _dev_identityId
    : (location.host.split('.')?.[0] || _dev_identityId);

/**
 * env
 * @param mode
 * @param env
 */
export function getEnv(mode: string) {
  const config = {
    routerBase: '/', // 路由基本路径
    viteBase: '/', // 打包的基本路径
    apiUrl: '',
  };

  // 打包环境
  const BuildEnv = ['devTest', 'sit', 'uat'];

  // if (mode === 'uat') {
  //   // uat环境
  //   config.apiUrl = `https://${identityId}.imgo.sz`;
  // } else if (mode === 'sit') {
  //   // sit环境
  //   config.apiUrl = `http://${identityId}.imgo.sz`;
  // } else if (mode === 'devTest') {
  //   // 线上dev环境
  //   config.apiUrl = `http://${identityId}.imgo.sz`;
  // } else {
  //   // 本地开发
  //   config.apiUrl = `http://4l6li7zz5lr8.imgo.sz`;
  //   // config.apiUrl = `http://${identityId}.im-dreaminglife.cn`;
  // }
  // 默认 apiUrl（打包按环境）。运行时若存在 public/web_config.json 会覆盖，便于运维通过 nginx 等配置
  // if (mode === 'uat') {
  //   config.apiUrl = `https://${identityId}.imsz.online`;
  // } else if (mode === 'sit') {
  //   config.apiUrl = `http://${identityId}.im-sit-dreaminglife.cn`;
  // } else if (mode === 'devTest') {
  //   config.apiUrl = `http://${identityId}.im-dreaminglife.cn`;
  // } else {
  //   config.apiUrl = '';
  // }
  if (typeof window !== 'undefined' && (window as any).WEB_CONFIG) {
    const { apiUrl } = (window as any).WEB_CONFIG;
    if (typeof apiUrl === 'string' && apiUrl) {
      config.apiUrl = apiUrl.replace(/\{\{identityId\}\}/g, identityId);
    }
  }
  // if (!config.apiUrl) {
  //   if (mode === 'uat') {
  //     config.apiUrl = `https://${identityId}.imsz.online`;
  //   } else if (mode === 'sit') {
  //     config.apiUrl = `http://${identityId}.im-sit-dreaminglife.cn`;
  //   } else if (mode === 'devTest') {
  //     config.apiUrl = `http://${identityId}.im-dreaminglife.cn`;
  //   } else {
  //     config.apiUrl = '';
  //   }
  // }
  if (BuildEnv.includes(mode)) {
    // 打包环境
    if (['devTest', 'sit'].includes(mode)) {
      // 打包到子路径(根据模式名字 作为 子路径名字)
      // config.routerBase = `/miner/`;
      // config.viteBase = `/miner/`;
    } else {
      // uat
      // 打包到根路径
    }
  } else {
    // 本地开发环境
  }

  return config;
}

export const ENV = getEnv(import.meta.env?.MODE);

